module.exports = __webpack_public_path__ + "static/img/102753.6c560b70.png";